import { I18nType } from '@affiliate-cabinet/i18n'

import { validationTranslationKeys } from './translations/validation.translationKeys'

export const passwordValidation = (i18n: I18nType) => (value: string) => {
  if (/\s/.test(value)) {
    return i18n.t(validationTranslationKeys.authFormErrorSpacings)
  }

  if (value.length < 8) {
    return i18n.t(validationTranslationKeys.authFormErrorPasswordIsToShort)
  }
}
